export default "__VITE_PUBLIC_ASSET__f776bfa9__"